
<i class="fa fa-info-circle" style="font-size: 20px; margin-top: 7px;" (click)="op.toggle($event)"></i>

<p-overlayPanel #op [showCloseIcon]="true" [style]="{width: width}">
    <ng-template pTemplate>
        <ng-content></ng-content>
    </ng-template>
</p-overlayPanel>
